import React from "react";
import Link from "next/link";
import { NEXT_PUBLIC_PHARMACY_BASE_URL } from "@/libs/constants/auth";
import styles from "./Breadcrumbs.module.scss";

export interface BreadcrumbOptionsInterface {
  label: string;
  url: string;
}

interface BreadcrumbsProps {
  options: BreadcrumbOptionsInterface[];
  variant?: string;
  className?: string;
}

export default function Breadcrumbs(props: BreadcrumbsProps) {
  const { options, variant, className = "" } = props;
  const numberOfOptions = options?.length;

  const createBreadcrumbSchema = () => {
    const itemListElement = options?.map((data, index) => {
      return {
        "@type": "ListItem",
        position: index + 1,
        name: data?.label,
        item: `${NEXT_PUBLIC_PHARMACY_BASE_URL}${data?.url}`,
      };
    });

    return {
      "@context": "https://schema.org/",
      "@type": "BreadcrumbList",
      itemListElement,
    };
  };

  return (
    <>
      <section>
        <script
          className="structured-data-list"
          type="application/ld+json"
          key={"breadCrumbSchema"}
          dangerouslySetInnerHTML={{
            __html: JSON.stringify(createBreadcrumbSchema()),
          }}
        ></script>
      </section>
      {options?.map((item, index) => {
        const { label, url } = item;
        const isLast = index === options?.length - 1;

        if (label?.length > 0) {
          return isLast ? (
            <div
              key={`${index}-breadcrumb`}
              className={`${styles.breadcrumbText}
              ${className}
              ${variant ? styles[variant] : ""}
              ${numberOfOptions - 1 === index ? styles.active : styles.nextItem}
              `}
            >
              {label}
            </div>
          ) : (
            <Link
              key={`${index}-breadcrumb`}
              href={url}
              className={`${styles.breadcrumbText}
              ${className}
              ${variant ? styles[variant] : ""}
              ${numberOfOptions - 1 === index ? styles.active : styles.nextItem}
              `}
              prefetch={false}
            >
              {label}
            </Link>
          );
        }
      })}
    </>
  );
}
